/*
 * Copyright 2015-2026 Ritense BV, the Netherlands.
 *
 * Licensed under EUPL, Version 1.2 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://joinup.ec.europa.eu/collection/eupl/eupl-text-eupl-12
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" basis,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

// Used by production/release builds via angular.json fileReplacements (swapped
// in for app-plugins.ts). CI installs the @valtimo-plugins/* packages from
// release-plugins.json before building.
import {SmtpMailPluginModule, smtpmailPluginSpecification} from '@valtimo-plugins/smtpmail';
import {
  DocumentGeneratorPluginModule,
  documentGeneratorPluginSpecification,
  MailTemplatePluginModule,
  mailTemplatePluginSpecification,
  TextTemplatePluginModule,
  textTemplatePluginSpecification,
} from '@valtimo-plugins/freemarker';

export const pluginImports = [
  SmtpMailPluginModule,
  DocumentGeneratorPluginModule,
  MailTemplatePluginModule,
  TextTemplatePluginModule,
];

export const pluginSpecifications = [
  smtpmailPluginSpecification,
  documentGeneratorPluginSpecification,
  mailTemplatePluginSpecification,
  textTemplatePluginSpecification,
];
